import React from "react";

const EditFieldModal = ({ isOpen, onClose, fieldData, onSave, content }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-3xl rounded-lg shadow-lg p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg text-[#333333] font-semibold">{content}</h2>
          <button onClick={onClose} className="text-xl font-bold scale-150">&times;</button>
        </div>
        <div className="w-full border-b border-gray-300 mb-5"></div>
        <div className="gap-5 grid grid-cols-2">
          <div>
            <label className="block text-sm font-medium text-[#333333]">
              Label<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={fieldData.label}
              onChange={(e) =>
                onSave({ ...fieldData, label: e.target.value })
              }
              className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md"
              placeholder="Field Label"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-[#333333]">
              Type<span className="text-red-500">*</span>
            </label>
            <select
              value={fieldData.type}
              onChange={(e) =>
                onSave({ ...fieldData, type: e.target.value })
              }
              className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md"
            >
              <option value="required">Required ( * )</option>
              <option value="optional">Optional</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-[#333333]">
              Placeholder<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={fieldData.placeholder}
              onChange={(e) =>
                onSave({ ...fieldData, placeholder: e.target.value })
              }
              className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md"
              placeholder="Enter Placeholder"
            />
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 rounded mr-5"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              // Save logic can go here
              onClose();
            }}
            className="px-6 py-2 bg-blue-600 text-white rounded"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditFieldModal;
